// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import PriceModel from '../../model/price-model';
import PriceDTO from '../dto/price-dto';
import dtoSchema from '../schemas/price-schema';

export default abstract class PriceModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<PriceDTO>) {
    super();
    if (data) {
      this.priceType = data.priceType ?? undefined;
      this.netPrice = data.netPrice;
      this.vatRate = data.vatRate;
      this.vatAmount = data.vatAmount;
      this.grossPrice = data.grossPrice;
    }
  }
  /**
  */
  priceType?: string;
  /**
  * @type {double}
  */
  netPrice?: number;
  /**
  * @type {double}
  */
  vatRate?: number;
  /**
  * @readonly
  * @type {double}
  */
  vatAmount?: number;
  /**
  * @readonly
  * @type {double}
  */
  grossPrice?: number;

  static toModel(dto: DeepPartial<PriceDTO>): PriceModel;
  static toModel(dto: DeepPartial<PriceDTO> | undefined | null): PriceModel | undefined;
  static toModel(dto: DeepPartial<PriceDTO> | undefined | null): PriceModel | undefined {
    return dto ? new PriceModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<PriceModel> | PriceModel): PriceDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      priceType: unwrapped.priceType,
      netPrice: unwrapped.netPrice,
      vatRate: unwrapped.vatRate,
      vatAmount: unwrapped.vatAmount,
      grossPrice: unwrapped.grossPrice,
    } as PriceDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for PriceModel, can not map to PriceDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
